import Vue from 'vue'
import Router from 'vue-router'
import routes from './router'
// import store from '@/store'
import iView from 'iview'
import { getToken } from '@/libs/util'
// import config from '@/configs'
// const { homeName } = config

/**
 * @description jsonp请求
 */
Vue.use(Router)
const router = new Router({
  routes,
  mode: 'history'
})

/* 避免在路由中添加了相同的路由报错 */
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}

const LOGIN_TO_PAGE_NAME = 'home'
const LOGIN_PAGE_HINT = 'hint'

// const turnTo = (to, access, next) => {
// if (canTurnTo(to.name, access, routes)) next() // 有权限，可访问
// else next({ replace: true, name: 'error_401' }) // 无权限，重定向到401页面
// }

router.beforeEach((to, from, next) => {
  console.log(to)
  iView.LoadingBar.start()
  const token = getToken()
  document.title = to.meta.title ? to.meta.title : ''
  if (!token && to.name === LOGIN_PAGE_HINT) {
    next({
      name: LOGIN_TO_PAGE_NAME
    })
  } else if (token && to.name === LOGIN_PAGE_HINT) {
    next()
  } else if (!token && to.name === LOGIN_TO_PAGE_NAME) {
    // 未登陆且要跳转的页面是首页
    next({
      params: {
        paymentId: to.params.paymentId
      }
    }) // 跳转
  } else if (token && to.name === LOGIN_TO_PAGE_NAME) {
    next({
      params: {
        paymentId: to.params.paymentId
      }
    }) // 跳转
  } else if (!token && to.name !== LOGIN_TO_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    let index = to.path.indexOf('/')
    let id = to.path.substr(index + 1, to.path.length)
    console.log(id)
    next({
      name: LOGIN_TO_PAGE_NAME, // 跳转到首页
      params: {
        paymentId: id
      }
    })
  } else {
    let index = to.path.indexOf('/')
    let id = to.path.substr(index + 1, to.path.length)
    next({
      name: LOGIN_TO_PAGE_NAME,
      params: {
        paymentId: id
      }
    })
  }
})

router.afterEach(to => {
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router
